import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SnackbarMsgService } from './snackbar-msg';
import { EMPTY, Observable, OperatorFunction, catchError, map, of } from 'rxjs';
import { IPagination } from 'app/core/http';

@Injectable({
  providedIn: 'root'
})
export class HttpBaseService {

  constructor(
    protected _http: HttpClient,
    protected _snackbarMsgService: SnackbarMsgService
  ) { }

  protected _mapPagination<T>(): OperatorFunction<HttpResponse<T[]>, { data: T[], pagination: IPagination }> {
    return map(response => {
      const pagination = JSON.parse(response.headers.get('X-Pagination'));
  
      return {
        data: response.body,
        pagination
      };
    });
  }

  protected _handleError<T>(isReturnEmpty: boolean = true, throwError = false): OperatorFunction<T, T> {
    return catchError((err: HttpErrorResponse) => {
      const errorMessage = err?.error?.message || "Algo deu errado";

      this._snackbarMsgService.error('Erro', errorMessage);

      if (throwError) {
        throw err;
      }

      return isReturnEmpty ? EMPTY : of([]) as Observable<T>;
    });
  }
}
